/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

export enum DisplayKey
{
    AutoSpin,
    Balance,
    Bet,
    Help,
    Lobby,
    Recall,
    RTP,
    ServerTime,
    SessionTime,
    Settings,
    Sound,
    Turbo,
    Social,
    ForWager,
    GameInfo,
    Demo,
    Language,
    QuickStop,
    KeyboardControls
}

const ccDisplayKey: typeof DisplayKey = cc.Enum(DisplayKey);
export { ccDisplayKey };
